import { Box, TextField, IconButton, Chip } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { greenColor } from '../utils/colors';

const ChipInputField = ({ value, setValue, chips, setChips, placeholder = 'Type here...', sx = {} }) => {
  const addChip = () => {
    if (value.trim() !== '') {
      setChips([...chips, value]);
      setValue('');
    }
  };

  const handleDeleteChip = (index) => {
    setChips(chips.filter((_, i) => i !== index));
  };

  return (
    <Box sx={{ ...sx }}>
      {/* Input Field & Add Button */}
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <TextField
          placeholder={placeholder}
          value={value}
          onChange={(e) => setValue(e.target.value)}
          fullWidth
          InputProps={{ sx: fieldSxWithBorder }} // You can replace with custom styles
        />
        <IconButton onClick={addChip}>
          <AddIcon sx={{ color: greenColor }} />
        </IconButton>
      </Box>

      {/* Chip Display */}
      <Box sx={{ mt: 1, display: 'flex', flexWrap: 'wrap', gap: 1 }}>
        {chips.map((chip, index) => (
          <Chip key={index} label={chip} onDelete={() => handleDeleteChip(index)} />
        ))}
      </Box>
    </Box>
  );
};

export default ChipInputField;


const fieldSxWithBorder = {
  backgroundColor: '#f5f5f5',
  borderRadius: '8px',
  '& fieldset': {
    borderColor: '#ccc'
  }
};
